import {IActionPassData, IFormStructure} from '../interface/form-structure';
import {IFieldShema} from '@usteknoloji/noosgrid';
import * as _ from 'lodash';

export class FormLoader {

    static loadFormOutData(formJson: IFormStructure, fieldStructure: IFieldShema[], outData: any) {
        if (outData === null || outData === undefined || outData.length === 0) {
            return false;
        }

        formJson.form_json.form_json.forEach(formRow => {
            formRow.rows.forEach(y => {
                y.cols.forEach(z => z.controls.forEach(control => {
                    const valueData = outData.filter(ff => ff.name === control.name);
                    console.log('valueData:', valueData);
                    if (valueData) {
                        control.defaultValue = valueData[0].value;
                    }
                }));
            });
        });
    }

    static loadFormFromRemoteData(formJson: IFormStructure, fieldStructure: IFieldShema[], rowData: any[], actionData: IActionPassData) {

        formJson.form_json.form_json.forEach(formRow => {
            if (formRow.option.dataset_id) {
                formRow.rows.forEach(y => {
                    y.cols.forEach(z => z.controls.forEach(control => {
                        const fieldData = fieldStructure.filter(fi => fi.dataset_id === formRow.option.dataset_id
                            && fi.field_name === control.name);
                        if (fieldData.length > 0) {
                            const valueData = rowData[fieldData[0].field_alias];
                            if (valueData) {
                                control.defaultValue = valueData;
                            }
                            const fieldLabelData = _.orderBy(fieldStructure.filter(fii => fii.source_table_name === fieldData[0].table_name
                                && fii.source_field_name === fieldData[0].field_name), ['list_order'], ['asc']);
                            if (fieldLabelData.length > 0) {
                                let valueLabelData = ''; // rowData[fieldLabelData[0].field_alias];
                                fieldLabelData.forEach(v => {
                                    valueLabelData += ' ' + rowData[v.field_alias];
                                });
                                if (valueLabelData !== '') {
                                    control.defaultValueTitle = valueLabelData.trim();
                                }
                            }

                        }
                        if (actionData !== undefined && actionData !== null && actionData.target_field_name !== undefined) {
                            if ((control.type === 'datasetselect' || control.type === 'dataset' || control.type === 'datasetsearch')
                                && control.name === actionData.target_field_name) {
                                control.defaultValue = actionData.record_id;
                                control.defaultValueTitle = actionData.title;
                                control.disabled = true;
                            }
                        }

                        if (control.options && control.options.currencyField && control.options.currencyField !== '') {
                            const fieldDataSuffix = fieldStructure.filter(fi => fi.dataset_id === formRow.option.dataset_id
                                && fi.field_name === control.options.currencyField);
                            if (fieldDataSuffix.length > 0) {
                                const valueData = rowData[fieldDataSuffix[0].field_alias];
                                control.suffixControlName = control.options.currencyField;
                                if (valueData) {
                                    control.suffixControlValue = valueData;
                                }
                            }
                        }

                        if (control.options && control.options.maskField && control.options.maskField !== ''
                            && control.defaultValue === '') {
                            const fieldDataMasked = fieldStructure.filter(fi => fi.dataset_id === formRow.option.dataset_id
                                && fi.field_name === control.options.maskField);
                            if (fieldDataMasked.length > 0) {
                                const valueData = rowData[fieldDataMasked[0].field_alias];
                                if (valueData) {
                                    control.defaultValue = valueData;
                                }
                            }
                        }

                    }));
                });
            }
        });
    }

    static setUpForm(formJson: IFormStructure) {
    }

    static loadActionData(formJson: IFormStructure, actionData: IActionPassData) {
        if (actionData === undefined || actionData === null || actionData.target_field_name === undefined) {
            return;
        }
        formJson.form_json.form_json.forEach(formRow => {
            if (formRow.option.dataset_id) {
                formRow.rows.forEach(y => {
                    y.cols.forEach(z => z.controls.forEach(control => {

                        if ((control.type === 'datasetselect' || control.type === 'dataset' || control.type === 'datasetsearch')
                            && control.name === actionData.target_field_name) {
                            control.defaultValue = actionData.record_id;
                            control.defaultValueTitle = actionData.title;
                            control.disabled = true;
                        }
                    }));
                });
            }
        });
    }

}
